module.exports = __webpack_public_path__ + "static/img/homeNavigation6.6ef2f987.png";